export default "__VITE_ASSET__b25ce9fc__"